<template>
    <div id="ctt-mobile-nav" class="ctt-mobile-nav">
        <button class="ctt-mobile-nav__close" @click="menuToggle"></button>
        <a @click.stop="switchTab('my_deck')"
           class="ctt-mobile-nav__link"
           data-formelementid="CARE_TO_TALK-BTN-CLK-MY_DECK"
           data-categoryid="caregiving"
           data-subcategoryid="care to talk"
        >
            <svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <rect opacity="0.3" y="2.14288" width="20" height="15.7143" rx="1"></rect>
                <rect x="4.28564" width="11.4286" height="20" rx="1"></rect>
            </svg>
            Cards
        </a>
        <div id="deck-switcher">
            <a
                v-if="deckTab === 'my_deck'"
                @click.stop="switchView('grid')"
                class="ctt-mobile-nav__link"
                style="margin-left: 30px; margin-top:10px;"
                data-formelementid="CARE_TO_TALK-BTN-CLK-VIEW-GRID"
                data-categoryid="caregiving"
                data-subcategoryid="care to talk"
            >
                <svg
                    aria-hidden="true"
                    width="20"
                    height="20"
                    viewBox="0 0 20 15"
                    fill="currentColor"
                >
                    <rect width="6.42857" height="6.42857" rx="1"></rect>
                    <rect x="8.57143" width="6.42857" height="6.42857" rx="1"></rect>
                    <rect y="8.57143" width="6.42857" height="6.42857" rx="1"></rect>
                    <rect x="8.57143" y="8.57143" width="6.42857" height="6.42857" rx="1"></rect>
                </svg>
                Grid
            </a>
            <a
                v-if="deckTab === 'my_deck'"
                @click.stop="switchView('stack')"
                class="ctt-mobile-nav__link"
                style="margin-left: 30px; margin-bottom: 10px"
                data-formelementid="CARE_TO_TALK-BTN-CLK-VIEW-STACK"
                data-categoryid="caregiving"
                data-subcategoryid="care to talk"
            >
                <svg
                    aria-hidden="true"
                    width="20"
                    height="20"
                    viewBox="0 0 20 15"
                    fill="currentColor"
                >
                    <rect opacity="0.3" y="1.60714" width="15" height="11.7857" rx="1"></rect>
                    <rect x="3.21429" width="8.57143" height="15" rx="1"></rect>
                </svg>
                Stack
            </a>
        </div>
        <a
            @click.stop="switchTab('caregiving_resources')"
            id="resources-mobile-btn"
            class="ctt-mobile-nav__link"
            data-formelementid="CARE_TO_TALK-BTN-CLK-CAREGIVING_RESOURCES"
            data-categoryid="caregiving"
            data-subcategoryid="care to talk"
        >
            <svg
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                version="1.1"
            >
                <g id="surface1">
                    <path
                        style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
                        d="M 15.320312 0 L 1.277344 0 C 1.101562 0 0.957031 0.144531 0.957031 0.320312 L 0.957031 19.679688 C 0.957031 19.855469 1.101562 20 1.277344 20 L 11.0625 20 C 11.074219 20 11.085938 20 11.09375 20 C 11.105469 19.996094 11.113281 19.996094 11.121094 19.996094 C 11.121094 19.996094 11.125 19.996094 11.125 19.992188 C 11.136719 19.992188 11.144531 19.988281 11.152344 19.988281 C 11.15625 19.988281 11.15625 19.988281 11.15625 19.984375 C 11.164062 19.984375 11.175781 19.980469 11.183594 19.976562 C 11.183594 19.976562 11.183594 19.976562 11.1875 19.976562 C 11.195312 19.972656 11.203125 19.96875 11.210938 19.964844 C 11.210938 19.964844 11.214844 19.964844 11.214844 19.960938 C 11.222656 19.957031 11.230469 19.953125 11.234375 19.949219 C 11.238281 19.949219 11.238281 19.949219 11.242188 19.945312 C 11.246094 19.941406 11.253906 19.9375 11.257812 19.933594 C 11.261719 19.929688 11.265625 19.929688 11.265625 19.925781 C 11.273438 19.921875 11.277344 19.917969 11.285156 19.910156 C 11.285156 19.910156 11.289062 19.910156 11.289062 19.90625 L 15.542969 15.652344 C 15.546875 15.648438 15.546875 15.648438 15.550781 15.644531 C 15.554688 15.640625 15.5625 15.632812 15.566406 15.628906 C 15.566406 15.625 15.570312 15.625 15.570312 15.621094 C 15.574219 15.617188 15.582031 15.609375 15.585938 15.601562 C 15.585938 15.601562 15.585938 15.597656 15.589844 15.597656 C 15.59375 15.589844 15.597656 15.582031 15.601562 15.578125 C 15.601562 15.574219 15.601562 15.574219 15.601562 15.570312 C 15.605469 15.5625 15.609375 15.554688 15.613281 15.546875 C 15.617188 15.535156 15.621094 15.527344 15.625 15.519531 C 15.625 15.519531 15.625 15.515625 15.625 15.515625 C 15.628906 15.507812 15.628906 15.496094 15.632812 15.488281 C 15.632812 15.484375 15.632812 15.484375 15.632812 15.480469 C 15.632812 15.472656 15.636719 15.464844 15.636719 15.457031 C 15.636719 15.445312 15.636719 15.4375 15.636719 15.425781 L 15.636719 0.320312 C 15.636719 0.144531 15.496094 0 15.320312 0 Z M 11.382812 18.910156 L 11.382812 15.746094 L 14.546875 15.746094 Z M 15 15.105469 L 11.0625 15.105469 C 10.886719 15.105469 10.746094 15.25 10.746094 15.425781 L 10.746094 19.363281 L 1.597656 19.363281 L 1.597656 0.636719 L 15 0.636719 Z M 15 15.105469 "
                    />
                    <path
                        style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
                        d="M 17.019531 0 L 16.597656 0 C 16.417969 0 16.277344 0.144531 16.277344 0.320312 C 16.277344 0.496094 16.417969 0.636719 16.597656 0.636719 L 16.703125 0.636719 L 16.703125 19.363281 L 12.871094 19.363281 C 12.691406 19.363281 12.550781 19.503906 12.550781 19.679688 C 12.550781 19.855469 12.691406 20 12.871094 20 L 17.019531 20 C 17.199219 20 17.339844 19.855469 17.339844 19.679688 L 17.339844 0.320312 C 17.339844 0.144531 17.199219 0 17.019531 0 Z M 17.019531 0 "
                    />
                    <path
                        style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
                        d="M 18.722656 0 L 18.296875 0 C 18.121094 0 17.980469 0.144531 17.980469 0.320312 C 17.980469 0.496094 18.121094 0.636719 18.296875 0.636719 L 18.402344 0.636719 L 18.402344 19.363281 L 18.296875 19.363281 C 18.121094 19.363281 17.980469 19.503906 17.980469 19.679688 C 17.980469 19.855469 18.121094 20 18.296875 20 L 18.722656 20 C 18.898438 20 19.042969 19.855469 19.042969 19.679688 L 19.042969 0.320312 C 19.042969 0.144531 18.898438 0 18.722656 0 Z M 18.722656 0 "
                    />
                </g>
            </svg>
            Caregiving Resources
        </a>
        <a @click.stop="openSuggestionModal"
           class="ctt-mobile-nav__link"
           data-formelementid="CARE_TO_TALK-BTN-CLK-SUGGEST_NEW"
           data-categoryid="caregiving"
           data-subcategoryid="care to talk"
        >
            <svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path
                    d="M18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 15C0 15.5304 0.210714 16.0391 0.585786 16.4142C0.960859 16.7893 1.46957 17 2 17H5V20L10 17H18C18.5304 17 19.0391 16.7893 19.4142 16.4142C19.7893 16.0391 20 15.5304 20 15V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0Z"
                ></path>
                <path
                    d="M8.97228 10.3508H10.8257V9.99175C10.8257 9.54608 10.9564 9.29849 11.3366 8.97662L11.8832 8.50619C12.5485 7.94911 13 7.19395 13 6.29023C13 4.84182 11.895 4 10.0178 4C8.12871 4 7 4.96561 7 6.40165C7 6.6121 7.02376 6.83494 7.08317 7.11967L8.91287 7.28061C8.85347 7.07015 8.84158 6.87208 8.84158 6.66162C8.84158 5.90647 9.29307 5.48556 10.0059 5.48556C10.6594 5.48556 11.0515 5.88171 11.0515 6.50069C11.0515 7.10729 10.7901 7.49106 10.3386 7.85007L9.73267 8.33288C9.1505 8.8033 8.97228 9.27373 8.97228 9.75653V10.3508ZM8.88911 13H10.9327V11.1059H8.88911V13Z"
                    fill="white"
                ></path>
            </svg>
            Suggest New
        </a>
        <a
            @click.stop="restartTourForGuest('deck', guest.id)"
            class="ctt-mobile-nav__link"
            v-if="! pageIsContentPage"
            data-formelementid="CARE_TO_TALK-BTN-CLK-RESTART_TOUR"
            data-categoryid="caregiving"
            data-subcategoryid="care to talk"
        >
            <svg
                aria-hidden="true"
                width="21"
                height="20"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
            >
                <path
                    d="M7 9h-7v-7h1v5.2c1.853-4.237 6.083-7.2 11-7.2 6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.286 0-11.45-4.844-11.959-11h1.004c.506 5.603 5.221 10 10.955 10 6.071 0 11-4.929 11-11s-4.929-11-11-11c-4.66 0-8.647 2.904-10.249 7h5.249v1z"
                />
            </svg>
            Restart Tour
        </a>
        <div class="ctt-mobile-nav__hr"></div>
        <!-- <div id="deck-share">
            <div class="ctt-mobile-nav__label">Share Cards</div>
            <a @click.stop="copyShareUrl()"
               class="ctt-mobile-nav__link"
               data-formelementid="CARE_TO_TALK-BTN-CLK-SHARE_MY_DECK-COPY_LINK"
               data-categoryid="caregiving"
               data-subcategoryid="care to talk"
            >
                <svg
                    aria-hidden="true"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                        d="M5.65217 20C4.16149 20 2.79503 19.375 1.67702 18.375C-0.559006 16.125 -0.559006 12.625 1.67702 10.375L2.54658 9.5L4.28571 11.25L3.41615 12.125C2.17391 13.375 2.17391 15.375 3.41615 16.625C4.65839 17.875 6.64596 17.875 7.8882 16.625L11.6149 12.875C12.8571 11.625 12.8571 9.625 11.6149 8.375L10.7453 7.5L12.4845 5.75L13.354 6.625C15.5901 8.875 15.5901 12.375 13.354 14.625L9.62733 18.375C8.63354 19.375 7.14286 20 5.65217 20Z"
                    ></path>
                    <path
                        d="M7.51553 14.25L6.64596 13.375C4.40994 11.125 4.40994 7.625 6.64596 5.375L10.3727 1.625C11.4907 0.5 12.8571 0 14.3478 0C15.8385 0 17.205 0.625 18.323 1.625C20.559 3.875 20.559 7.375 18.323 9.625L17.4534 10.5L15.7143 8.75L16.5839 7.875C17.8261 6.625 17.8261 4.625 16.5839 3.375C15.3416 2.125 13.354 2.125 12.1118 3.375L8.38509 7.125C7.14286 8.375 7.14286 10.375 8.38509 11.625L9.25466 12.5L7.51553 14.25Z"
                    ></path></svg
                >Copy Link
            </a>
            <a @click.stop="sendMail()"
               class="ctt-mobile-nav__link"
               data-formelementid="CARE_TO_TALK-BTN-CLK-SHARE_MY_DECK-EMAIL"
               data-categoryid="caregiving"
               data-subcategoryid="care to talk"
            >
                <svg
                    aria-hidden="true"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                        d="M17.5 1.25H2.5C1.83696 1.25 1.20107 1.51339 0.732233 1.98223C0.263392 2.45107 0 3.08696 0 3.75L0 4.25L10 9.875L20 4.375V3.75C20 3.08696 19.7366 2.45107 19.2678 1.98223C18.7989 1.51339 18.163 1.25 17.5 1.25Z"
                    ></path>
                    <path
                        d="M9.375 12.3747L0 7.12469V16.2497C0 16.9127 0.263392 17.5486 0.732233 18.0175C1.20107 18.4863 1.83696 18.7497 2.5 18.7497H17.5C18.163 18.7497 18.7989 18.4863 19.2678 18.0175C19.7366 17.5486 20 16.9127 20 16.2497V7.12469L10.625 12.3747C10.428 12.4612 10.2152 12.5059 10 12.5059C9.78483 12.5059 9.572 12.4612 9.375 12.3747Z"
                    ></path>
                </svg>
                Email
            </a>
        </div> -->
        <div class="ctt-mobile-nav__foot">
            <div class="profile-nav">
            </div>

            <!--        <a href="/logout" class="ctt-mobile-nav__logout">Log Out</a>-->
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import collectorActions from '../../../mixins/collectorActions';
import Tour from '../../../mixins/Tour';
import Rewards from '../../../mixins/rewards';
export default {
    name: 'deck-mobile-nav',
    mixins: [collectorActions, Tour, Rewards],
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            guest: 'guest',
            showBackButton: 'showBackButton',
            deckView: 'deckView',
            deckTab: 'deckTab'
        }),
        cardsUrl() {
            return window.location.origin + '/shared-deck/' + this.guest.uuid;
        },
        pageIsContentPage() {
            return window.location.pathname.includes('content/');
        }
    },
    methods: {
        switchTab(tabName) {
            this.switchView('grid');
            this.$store.commit('SET_DECK_TAB', tabName);

            if (tabName === 'my_deck') {
                history.replaceState(null, null, ' ');
            } else {
                window.location.hash = tabName;
            }

            switch (tabName) {
                case 'my_deck':
                    this.deckMyDeck();
                    break;
                case 'customize':
                    this.deckCustomize();
                    break;
                case 'caregiving_resources':
                    this.deckCaregivingResources();
                    break;
                default:
                    this.deckMyDeck();
            }
        },
        switchView(viewType) {
            this.menuToggle();
            this.$store.commit('SET_DECK_VIEW', viewType);

            if (viewType === 'grid') {
                this.deckSelectGridView();
            } else {
                this.deckSelectStackView();
            }
        },
        openSuggestionModal() {
            this.$store.commit('SET_SHOW_SUGGESTION_MODAL', true);
            this.deckOpenSuggestModal();
            this.menuToggle();
        },
        menuToggle() {
            document.getElementById('ctt-mobile-nav').classList.toggle('active');
        },
        async copyShareUrl() {
            this.distributeReward(this.guest);

            if (this.guest.user_fedid && AARP.store.getState().cookie.fedid !== undefined) {
                try {
                    if (! AARP.store.getState().user.rewardsUser && ! this.dismissedRewardsModal) {
                        this.$store.commit('SET_SHOW_REWARDS_MODAL', true);
                    }

                    this.generateAndCopyShareLink();
                } catch($e) {
                    console.log($e);
                }
            } else {
                this.$store.commit('SET_SHOW_LOGIN_MODAL', true);
            }
        },
        generateAndCopyShareLink() {
            this.deckShareLink();
            this.copyToClipboard(this.cardsUrl)
            this.$store.commit('SET_SNACKBAR_MESSAGE', 'Deck URL copied to clipboard');
        },
        shareEmail() {
            this.deckShareEmail();

            this.$store.dispatch('sendAARPEmail', {
                email: AARP.store.getState().cookie.at.e,
                fedid: AARP.store.getState().cookie.fedid,
            }).then(res => {
                if (res.status === 200) {
                    this.$store.commit('SET_SNACKBAR_MESSAGE', 'Email sent to ' + AARP.store.getState().cookie.at.e);
                }
            }).catch(error => {
                console.log(error);
            });
        },
        sendMail() {
            // @todo-SSO when SSO ready make this work
            this.distributeReward(this.guest);

            if (this.guest.user_fedid && AARP.store.getState().cookie.fedid !== undefined) {
                if (! AARP.store.getState().user.rewardsUser && !this.dismissedRewardsModal) {
                    this.$store.commit('SET_SHOW_REWARDS_MODAL', true);
                }

                this.shareEmail();
            } else {
                this.$store.commit('SET_SHOW_LOGIN_MODAL', true);
            }
        }
    }
};
</script>

<style lang="scss"></style>
